const palette = {
  theme: ['#DBDBDD', '#E0EFFF', '#007AFF', '#174F98'],
  gray: [
    '#f8f9fa',
    '#f1f3f5',
    '#e9ecef',
    '#dee2e6',
    '#ced4da',
    '#adb5bd',
    '#868e96',
    '#495057',
    '#343a40',
    '#212529',
  ],
  background: '#f5f5f5',
};

export default palette;
